import React from 'react';

interface FupNandProps {
  width?: number;
  height?: number;
}

const FupNand: React.FC<FupNandProps> = ({ width = 80, height = 60 }) => (
  <svg width={width} height={height} viewBox="0 0 80 60" xmlns="http://www.w3.org/2000/svg">
    {/* AND-Körper */}
    <rect x="5" y="10" width="35" height="40" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    <path d="M 40 10 L 40 50 Q 62 30 40 10" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    
    {/* Negation-Kreis */}
    <circle cx="67" cy="30" r="5" fill="none" stroke="#0D3559" strokeWidth="2" />
    
    {/* Eingangs-Ankerpunkte */}
    <circle cx="5" cy="20" r="3" fill="#0D3559" />
    <circle cx="5" cy="40" r="3" fill="#0D3559" />
    
    {/* Ausgangs-Ankerpunkt */}
    <circle cx="75" cy="30" r="3" fill="#0D3559" />
    
    {/* Label */}
    <text x="23" y="35" fontSize="12" fill="#0D3559" textAnchor="middle" fontWeight="bold">&amp;</text>
  </svg>
);

export default FupNand;
